<template>
    <BModal :model-value="modal" scrollable centered @update:modelValue="updateModal" >
        <template #header>
            <div class="d-flex align-items-center justify-content-between modal-title w-100">
                <h5 class="">Transportation</h5>
            </div>
            <BButton
                variant="link"
                class="close"
                @click="$emit('updateModal', false)"
            >
                <i class="ion ion-android-close"></i>
            </BButton>
        </template>

        <BForm>
            <BContainer>
                
                <BRow>
                    <BCol>
                        <BFormSelect v-model="selectCarType.selected" :options="selectCarType.data"/>
                    </BCol>
                    <BCol>
                        <BFormInput type="number" id="input-1" v-model="contact" :state="state" placeholder="Pax" class="form-group" />
                    </BCol>
                </BRow>
                <BRow >
                    <BCol>
                        <BFormInput type="number" id="input-1" v-model="contact" :state="state" placeholder="Price" class="form-group" />
                    </BCol>
                </BRow>
                
                
                
            </BContainer>
            
                
        
        </BForm>

        <template #footer>
            <div class="d-flex justify-content-end">
                <BButton variant="primary"  class="mr-2">Save</BButton>
                <BButton variant="danger" @click="$emit('updateModal', false)">Cancel</BButton>
            </div>
        </template>
    </BModal>
</template>

<script>
import { BModal,BRow, BCol, BForm, BFormInput, BFormSelect, BButton } from 'bootstrap-vue-next';
import { ref } from 'vue';

export default{
    name : 'TransportationForm',
    components : { BModal,BRow, BCol, BForm, BFormInput, BFormSelect, BButton },
    props : { modal : Boolean },
    setup(props, { emit }){
        const selectCarType = ref({
            selected : '-',
            data : [
                {value : '-', text : 'Choose Car'},
                {value : 'Avanza', text : 'Avanza'},
                {value : 'Xenia', text : 'Xenia'},
            ]
        })
        const updateModal = (value) => {
            emit("update:modal", value); // Sync modal state with parent
        };
        return { 
            selectCarType,
            updateModal
        }
    }
   
}
</script>

<!-- <script setup>



defineProps({
    modal: Boolean,
    updateModal: Function
})

const selectCarType = reactive({
    selected : '-',
    data : [
        {value : '-', text : 'Choose Car'},
        {value : 'Avanza', text : 'Avanza'},
        {value : 'Xenia', text : 'Xenia'},
    ]
})



</script>
 -->
